/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOpportunityTestFixtureRequest
 */
export interface CreateOpportunityTestFixtureRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOpportunityTestFixtureRequest
     */
    authorIdentityId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOpportunityTestFixtureRequest
     */
    clientIdentityId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOpportunityTestFixtureRequest
     */
    freelancerAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOpportunityTestFixtureRequest
     */
    freelancerEmail: string;
}

/**
 * Check if a given object implements the CreateOpportunityTestFixtureRequest interface.
 */
export function instanceOfCreateOpportunityTestFixtureRequest(value: object): value is CreateOpportunityTestFixtureRequest {
    if (!('authorIdentityId' in value) || value['authorIdentityId'] === undefined) return false;
    if (!('clientIdentityId' in value) || value['clientIdentityId'] === undefined) return false;
    if (!('freelancerEmail' in value) || value['freelancerEmail'] === undefined) return false;
    return true;
}

export function CreateOpportunityTestFixtureRequestFromJSON(json: any): CreateOpportunityTestFixtureRequest {
    return CreateOpportunityTestFixtureRequestFromJSONTyped(json, false);
}

export function CreateOpportunityTestFixtureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOpportunityTestFixtureRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'authorIdentityId': json['authorIdentityId'],
        'clientIdentityId': json['clientIdentityId'],
        'freelancerAccountId': json['freelancerAccountId'] == null ? undefined : json['freelancerAccountId'],
        'freelancerEmail': json['freelancerEmail'],
    };
}

export function CreateOpportunityTestFixtureRequestToJSON(value?: CreateOpportunityTestFixtureRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'authorIdentityId': value['authorIdentityId'],
        'clientIdentityId': value['clientIdentityId'],
        'freelancerAccountId': value['freelancerAccountId'],
        'freelancerEmail': value['freelancerEmail'],
    };
}

